var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"the-overlay"}},[(_vm.isVisible)?_c('div',{staticClass:"the-overlay the-overlay-enter",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }